const palette = [
  '#3399CC', // Light Blue
  '#CC6666', // Light Red
  '#99CC66', // Light Green
  '#275378', // Blue
  '#B35A01', // Orange
  '#B974FD', // Purple
  '#993300', // Dark Red
  '#99CCCC', // Very light blue
  '#669933', // Green
  '#898989', // Gray
  '#EDA1A1',
  '#C6E2A9',
  '#D4B881',
  '#137D77', // Dark Green
  '#D7C2EC', // Light purple
  '#FF5500', // Bright Orange
  '#15DFDF', // Terquase
  '#93A77E', // Olive Green
  '#CB5090', // Dark Pink
  '#BFBFBF', // Light Gray
  '#d6d6d6', // Lighter Gray
  '#eaeaea', // Even Lighter Gray
];

const theme = {
  palette,
  primary: palette[3],
  primaryLight: palette[0],
  secondary: palette[4],
  secondaryLight: palette[1],
  tertiary: palette[8],
  tertiaryLight: palette[2],
  quaternary: {},
  quinary: {},
  senary: {},
};

export default theme;
